export default async function init() {
  const element = document.querySelector('.contributors-list');

  if (element) {
    const { default: ContributorsList } = await import(/* webpackChunkName: "contributors-list" */ './contributors-list');

    new ContributorsList(element);
  }
}
